import styled from 'styled-components'
import { Button } from 'pcln-design-system'

const StyledMenuButtonRemaining = styled(Button)`
  position: relative;
  align-items: center;
  height: ${props => (props.isMobile ? '46' : '56')}px;
`
// split the styles and added &&& to increase css rule specificity because of a bug in DS 4.16.2
// scrolling scroll down then up on hotels page breaks traveller selection
const StyledMenuButton = styled(StyledMenuButtonRemaining)`
  &&& {
    display: flex;
    padding: 0px;
  }
`

export default StyledMenuButton
